import { Button, CircularProgress, Stack, SvgIcon, Typography } from "@mui/material"
import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next";
import AddIcon from '@mui/icons-material/Add';
import { Link } from "react-router-dom";
import { tokens } from "../../../../../locales/tokens";
import { getStyles } from "./styles";
import { paths } from "../../../../../paths";
import { SearchInput } from "../../../../../ui-kit/searchInput/searchInput";
import { useTestList } from "../presenters/useTestList";
import { TabsChanger } from "../../../../../ui-kit/tabsChanger";
import { Filters } from "../../../../../ui-kit/listFilters";
import { EmptyPage } from "../../../category/categoryEmpty/ui";
import { TestTable } from "./components/testTable";

export const Tests: FC = () => {
    const { t } = useTranslation();
    const styles = useMemo(() => getStyles(), []);
    const { searchText, handleSearchTestText, filters, handleTabsChange, orgStructure, onSelectInitiator, onChangeInitiator, handleDateChange, scrollRef,
        changeStatus, resetFilters, testList, handlePageChange, pageAmount, handleStatus, handleDelete, handleUploadReport, isProccessTest } = useTestList();
 
    return (
        <Stack m={2}>
            <Stack>
                <Stack direction='row' justifyContent='space-between'>
                    <Typography variant="h5" fontWeight={600}>
                        {t(tokens.test.testList)}
                    </Typography>
                    <Button
                        startIcon={(<SvgIcon><AddIcon /></SvgIcon>)}
                        variant="contained"
                        sx={styles.createBtn}
                        component={Link}
                        to={paths.dashboard.content.test.create}
                    >
                        {t(tokens.common.create)}
                    </Button>
                </Stack>
                <Stack mt={3}>
                    <SearchInput
                        searchText={searchText}
                        label={t(tokens.test.searchTestByTitle)}
                        handleSearch={handleSearchTestText}
                        size="small"
                    />
                </Stack>
                <Filters
                    filters={filters}
                    orgStructure={orgStructure}
                    changeStatus={changeStatus}
                    resetFilters={resetFilters}
                    handleDateChange={handleDateChange}
                    onSelectInitiator={onSelectInitiator}
                    onChangeInitiator={onChangeInitiator}
                />
                <TabsChanger
                    tab={filters.tab}
                    handleTabsChange={handleTabsChange}
                />
            </Stack>
            {testList?.length > 0 &&
                <TestTable
                    scrollRef={scrollRef}
                    page={filters.page}
                    testList={testList}
                    handlePageChange={handlePageChange}
                    pageAmount={pageAmount}
                    handleStatus={handleStatus}
                    handleDelete={handleDelete}
                    handleUpload={handleUploadReport}
                />
            }
            {(!testList?.length && isProccessTest) &&
                <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={styles.progress}
                >
                    <CircularProgress color="primary" />
                </Stack>
            }
            {(!testList?.length && !isProccessTest) &&
                <Stack>
                    <EmptyPage
                        title={t(tokens.test.emptyList)}
                        description={t(tokens.test.emttyStateDesc)}
                    />
                </Stack>
            }
        </Stack>
    )
};